import { compressorIsInstalled } from "../Kompressor";
import { postJSONexpectJSON } from "../../netzwerk/FetchWithToken";

import { setDailyRequestPending, setDailyValuesAction, sameDay }
	from "../Diagramme";

export const requestDailyStatistics = (type, from_ms, until_ms, dispatch) => {
	dispatch(setDailyRequestPending(type, true));
	postJSONexpectJSON("/daily_statistics/get_stat", { type, from_ms, until_ms }).then(response => {
		if (!response.ok) {
			return response.text().then(text => { throw(text); });
		}
		return response.json();
	}).then(body => {
		dispatch(setDailyValuesAction(type, body, from_ms, until_ms, Date.now()));
	}).catch(error => {
		dispatch(setDailyRequestPending(type, false));
		/*
		 * irgendwie muss ich das schon noch handlen und schoener machen.
		 * fuer den augenblick, muss console.log reichen :-(
		 */
		console.log(error);
	});
};

/* Benötigt:
 * props.model -> z.B. daily_values.last_leerlauf
 *       last_request_ms -> letzte Abfrage
 *       from_ms, until_ms -> letzter erhaltener Zeitraum
 * props.timespan -> gewünschter Zeitraum
 * props.rtc -> aktuelle Systemzeit
 */
export const checkDailyProps = props => {
	if (props.model.request_pending) {
		return;
	}
	let should_update = false;
	if (!props.model.last_request_ms) {
		should_update = true;	/* wurde noch nie abgefragt! */
	} else if (props.model.from_ms !== props.timespan.from_ms &&
		props.model.until_ms !== props.timespan.until_ms) {
		should_update = true;	/* Anfragezeitraum hat sich geändert */
	} else if (sameDay(props.timespan.until_ms, props.rtc) &&
		Date.now() - props.model.last_request_ms > 60 * 1000) {
		should_update = true;	/* Abfrage inklusive heute: periodisch anfragen */
	}
	if (should_update) {
		props.refresh(props.timespan);
	}
};

export const filterDataCompressorsLastLeerlauf = (data, compressors) => {
	let data_filtered = data.data.filter((c) => {
		return (
			compressorIsInstalled(compressors[c.cindex])
			|| (c.lastlauf_s !== 0)
			|| (c.leerlauf_s !== 0)
		);
	});
	data.data = data_filtered;
	return data;
};

export const filterDataCompressorsMotorstarts = (data, compressors) => {
	let data_filtered = data.data.filter((c) => {
		return (compressorIsInstalled(compressors[c.cindex])
			|| (c.motorstarts !== 0)
		);
	});
	data.data = data_filtered;
	return data;
};

export const filterDataCompressorsLeistungsaufnahme = (data, compressors) => {
	let data_filtered = data.data.filter((c) => {
		return (
			(c.cindex === -1)		// station!
			|| compressorIsInstalled(compressors[c.cindex])
			|| ((c.gesamtspezifische_leistung_kWhm3 !== null) && (c.gesamtspezifische_leistung_kWhm3 !== 0))
			|| ((c.spezifische_leistung_kWhm3 !== null) && (c.spezifische_leistung_kWhm3 !== 0))
		);
	});
	data.data = data_filtered;
	return data;
};

export const filterDataCompressorsEnergieverbrauch = (data, compressors) => {
	let data_filtered = data.data.filter((c) => {
		return (
			(c.cindex === -1)		// station!
			|| compressorIsInstalled(compressors[c.cindex])
			|| ((c.gesamtenergie_kWh !== null) && (c.gesamtenergie_kWh !== 0))
			|| ((c.lastenergie_kWh !== null) && (c.lastenergie_kWh !== 0))
		);
	});
	data.data = data_filtered;
	return data;
};